import { deleteSearchParams, setSearchParamValue } from 'lib/url/searchUrlUtils'

type RoomFilterType = 'bedrooms' | 'beds' | 'bathrooms'

const roomFilterParamMap: Record<RoomFilterType, { gte: string, eq: string }> = {
  bedrooms: { gte: 'bedroomsGte', eq: 'bedroomsEq' },
  beds: { gte: 'bedsGte', eq: 'bedsEq' },
  bathrooms: { gte: 'bathroomsGte', eq: 'bathroomsEq' },
}

export function updateRoomFilterSearch(search: string, filterType: RoomFilterType, value: number) {
  const params = roomFilterParamMap[filterType]

  if (value === 0) {
    return deleteSearchParams(search, params.gte, params.eq)
  }

  const nextSearch = setSearchParamValue(search, params.gte, value)
  return deleteSearchParams(nextSearch, params.eq)
}

/**
 * Treatment bedrooms radios: Studio/1 and 2 write exact `bedroomsEq`;
 * 3+ writes `bedroomsGte`; Any clears both.
 * Radio values mirror BEDROOMS_RADIO_* in BedroomsRadioFilterGroup.
 */
export function updateBedroomsRadioFilterSearch(search: string, radioValue: number) {
  const params = roomFilterParamMap.bedrooms

  if (radioValue === 0) {
    return deleteSearchParams(search, params.gte, params.eq)
  }

  // Studio/1 and 2 bedrooms → exact match
  if (radioValue === 1 || radioValue === 2) {
    const nextSearch = setSearchParamValue(search, params.eq, radioValue)
    return deleteSearchParams(nextSearch, params.gte)
  }

  const nextSearch = setSearchParamValue(search, params.gte, radioValue)
  return deleteSearchParams(nextSearch, params.eq)
}
